// Update targeting
import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

// Get targeting
export const dv360TargetingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Targeting.results,
  results => results
)

export const targetingIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Targeting.isLoading,
  isLoading => isLoading
)

export const targetingErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Targeting.error,
  error => error
)

export const targetingWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Targeting.wasLoaded,
  wasLoaded => wasLoaded
)

// Search targeting options
export const searchDv360TargetingOptionsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.searchDv360TargetingOptions.results,
  results => results
)
export const searchDv360TargetingOptionsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.searchDv360TargetingOptions.isLoading,
  isLoading => isLoading
)
export const searchDv360TargetingOptionsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.searchDv360TargetingOptions.error,
  error => error
)
export const searchDv360TargetingOptionsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.searchDv360TargetingOptions.wasLoaded,
  wasLoaded => wasLoaded
)

// Update bulk targeting
export const updateDv360BulkTargetingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.updateDv360BulkTargeting.data,
  data => data
)

export const updateDv360BulkTargetingIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.updateDv360BulkTargeting.isLoading,
  isLoading => isLoading
)

export const updateDv360BulkTargetingErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.updateDv360BulkTargeting.error,
  error => error
)

export const dv360BulkTargetingWasUpdatedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.updateDv360BulkTargeting.wasUpdated,
  wasUpdated => wasUpdated
)

// Get dv360 targeting options
export const dv360TargetingOptionsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360TargetingOptions.results,
  results => results
)

export const getDv360TargetingOptionsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360TargetingOptions.isLoading,
  isLoading => isLoading
)

export const getDv360TargetingOptionsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360TargetingOptions.error,
  error => error
)

export const dv360TargetingOptionsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360TargetingOptions.wasLoaded,
  wasLoaded => wasLoaded
)

// Get dv360 exchange targeting options
export const dv360ExchangeTargetingOptionsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ExchangeTargetingOptions.results,
  results => results
)

export const getDv360ExchangeTargetingOptionsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ExchangeTargetingOptions.isLoading,
  isLoading => isLoading
)

export const getDv360ExchangeTargetingOptionsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ExchangeTargetingOptions.error,
  error => error
)

export const dv360ExchangeTargetingOptionsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ExchangeTargetingOptions.wasLoaded,
  wasLoaded => wasLoaded
)

// Get dv360 viewability targeting options
export const dv360ViewabilityTargetingOptionsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ViewabilityTargetingOptions.results,
  results => results
)

export const getDv360ViewabilityTargetingOptionsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ViewabilityTargetingOptions.isLoading,
  isLoading => isLoading
)

export const getDv360ViewabilityTargetingOptionsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ViewabilityTargetingOptions.error,
  error => error
)

export const dv360ViewabilityTargetingOptionsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360ViewabilityTargetingOptions.wasLoaded,
  wasLoaded => wasLoaded
)

// Get dv360 channels
export const dv360ChannelsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Channels.results,
  results => results
)

export const getDv360ChannelsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Channels.isLoading,
  isLoading => isLoading
)

export const getDv360ChannelsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Channels.error,
  error => error
)

export const dv360ChannelsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360Channels.wasLoaded,
  wasLoaded => wasLoaded
)

// Get dv360 negative keyword lists
export const dv360NegativeKeywordListsSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360NegativeKeywordLists.results,
  results => results
)

export const getDv360NegativeKeywordListsIsLoadingSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360NegativeKeywordLists.isLoading,
  isLoading => isLoading
)

export const getDv360NegativeKeywordListsErrorSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360NegativeKeywordLists.error,
  error => error
)

export const dv360NegativeKeywordListsWasLoadedSelector = createSelector(
  ({ dv360Constants }) => dv360Constants.dv360NegativeKeywordLists.wasLoaded,
  wasLoaded => wasLoaded
)
